import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const savedTheme = localStorage.getItem('erp_theme') || 'dark';
document.documentElement.dataset.theme = savedTheme;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enables installation on mobile without caching ERP screens or API responses.
if ('serviceWorker' in navigator && window.location.protocol === 'https:') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/erp/service-worker.js', { scope: '/erp/' }).catch(() => {
      // Installation is optional; the ERP remains fully usable in the browser.
    });
  });
}
